module.exports = __webpack_public_path__ + "static/media/Face_detection@2x.48ab5594.png";